var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchFilterWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2.375L12.6667 11.875M12.6667 11.875C11.355 11.875 10.2917 12.9383 10.2917 14.25C10.2917 15.5616 11.355 16.625 12.6667 16.625C13.9783 16.625 15.0417 15.5616 15.0417 14.25C15.0417 12.9383 13.9783 11.875 12.6667 11.875ZM6.33334 7.12499L6.33334 16.625M6.33334 7.12499C5.02167 7.12499 3.95835 6.06167 3.95835 4.74999C3.95835 3.43832 5.02167 2.375 6.33334 2.375C7.64502 2.375 8.70834 3.43832 8.70834 4.75C8.70834 6.06167 7.64502 7.12499 6.33334 7.12499Z",
    stroke: "white",
    strokeWidth: 1.75384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilterWhiteIcon);
export default __webpack_public_path__ + "static/media/search-filter-white_Icon.4eead96bf99ac17948f1da3f37c71c09.svg";
export { ForwardRef as ReactComponent };